import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { IMetaAdAccount } from '../../extViewmodels/sdk/models/Ads';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { reactQueryClient } from '../../web/ReactQueryProvider';

const BASE_QUERY_KEY = 'getMetaAdAccounts';

export const useGetMetaAdAccounts = ({
	impersonationContext,
	enabled = true,
}: {
	impersonationContext?: Api.IImpersonationContext;
	enabled?: boolean;
}) => {
	const userSession = useUserSession();

	return useQuery({
		queryFn: () => {
			return userSession.webServiceHelper.callAsync<IMetaAdAccount[]>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: 'ads/providers/meta/adAccounts',
				}),
				'GET'
			);
		},
		queryKey: [BASE_QUERY_KEY, impersonationContext],
		enabled,
		refetchOnWindowFocus: false,
		retry: false,
	});
};

export const invalidateMetaAdAccounts = ({
	impersonationContext,
}: {
	impersonationContext?: Api.IImpersonationContext;
} = {}) => {
	return reactQueryClient.invalidateQueries({ queryKey: [BASE_QUERY_KEY, impersonationContext] });
};
